import { combineReducers } from "redux";
import ToDo from "./SelectorAndTests/reducer";
import Auth from "./Auth/user";
import General from "./general";

export default combineReducers({
  ToDo,
  Auth,
  General,
});
